export default "__VITE_ASSET__DFxuv78i__"